/**
 * Shared types + helpers for the vibecoder layout-assistant chat, used by both
 * the inline editor (`SectionEditorPanel`) and the per-section editor store
 * slice (`formSchemaEditorSlice`) so an in-flight chat request can live in the
 * store and survive section switches.
 */

export type VibecoderChatImage = {
  media_type: 'image/jpeg' | 'image/png' | 'image/gif' | 'image/webp';
  data: string;
  filename?: string;
};

export type VibecoderChatTurn = {
  role: 'user' | 'assistant';
  content: string;
  /** What to send to the LLM (may include extra context); falls back to `content`. */
  llmContent?: string;
  images?: VibecoderChatImage[];
};

/** Strip fenced JSON models sometimes paste into assistant_message; layout lives in layout_json only. */
export function sanitizeVibecoderAssistantDisplay(text: string): string {
  return text
    .replace(/```(?:json)?\s*[\s\S]*?```/gi, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
